<script setup lang="ts">
import { useWordProcessorStore } from "../useWordProcessorStore";

const editorRef = inject("quillEditor") as any;

const wordProcessorInstanceId = inject("instanceId") as string;
const wordProcessorStore = useWordProcessorStore(wordProcessorInstanceId);
const { selectionRange } = storeToRefs(wordProcessorStore);

const setLineSpacing = (spacing: number) => {
  const quill = editorRef.value?.getQuill?.();

  if (!quill) return;
  const range = quill.getSelection(true);
  if (!range) return;

  quill.format("lineheight", String(spacing));
};

const activeLineSpacing = computed(() => {
  const quill = wordProcessorStore.getQuillInstance();
  if (!quill) return 2;
  const selection = selectionRange.value ?? quill.getSelection();
  if (!selection) {
    return Number(quill.getFormat(0, 0).lineheight ?? 1);
  }
  const format = quill.getFormat(selection.index, selection.length);
  return Number(format.lineheight ?? 1);
});

const lineSpacingOptions = computed(() => {
  return [
    { value: 1, label: "Single" },
    { value: 1.5, label: "1.5" },
    { value: 2, label: "Double" },
  ];
});
</script>

<template>
  <BasePopover align="start" trigger-class="!w-[30px] !h-[30px] !p-0 rounded">
    <div
      v-tooltip="'Line Spacing'"
      class="w-[30px] h-[30px] rounded hover:bg-light flex items-center justify-center"
    >
      <BaseIconLineSpace />
    </div>
    <template #content>
      <div class="p-2 w-[220px]">
        <div class="font-semibold pb-2 border-b mb-2 text-body-2">
          Line Spacing
        </div>
        <BaseTextButton
          v-for="option in lineSpacingOptions"
          :key="option.value"
          :class="{
            'bg-light text-primary font-medium':
              activeLineSpacing === option.value,
          }"
          class="w-full !h-8 !px-2 rounded-md transition-colors duration-150 hover:bg-light flex items-center gap-2"
          @click="setLineSpacing(option.value)"
        >
          <span
            class="inline-flex w-4 items-center justify-center transition-opacity duration-150"
            :class="{
              'opacity-100': activeLineSpacing === option.value,
              'opacity-0': activeLineSpacing !== option.value,
            }"
          >
            <BaseIconCheck />
          </span>
          <span class="flex items-center justify-start w-full text-sm">
            {{ option.label }}
          </span>
        </BaseTextButton>
      </div>
    </template>
  </BasePopover>
</template>

<style scoped></style>
